<div class="content-wrapper">

    <section class="content-header">
        <h1>
            Cronograma Financeiro
            <small>Criar, listar e editar</small>
        </h1>
        <ol class="breadcrumb">
            <li>
                <a routerLink="/home">
                    <i class="fa fa-home"></i> Home</a>
            </li>
            <li class="active">Cronograma Financeiro</li>
        </ol>
    </section>

    <br>

    <div class="col-md-12">
        <div class="box box-primary">
            <div class="box-header with-border">
                <h3 class="box-title">Gerenciar conteúdo</h3>
            </div>

            <br>

            <div class="box-body no-padding">

                <div class="col-md-7">
                    <form autocomplete="off" (ngSubmit)="pesquisar()">
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control" name="titulo" placeholder="Pesquisar por Entidade Concedente" [(ngModel)]="filtro.entidadeConcedente">
                            <span class="input-group-btn">
                                <button type="submit" class="btn btn-primary ">
                                    <i class="fa fa-search"></i>
                                </button>
                            </span>
                        </div>
                                <div class="form-group col-sm-12 no-padding" style="margin-top: 8px;">
                <label class="checkbox-inline">
                    <input type="checkbox" [(ngModel)]="manterFiltrosSelecionados" name="manterFiltrosSelecionados"
                        (ngModelChange)="alterarManterFiltrosSelecionados($event)">
                    Manter filtros selecionados
                </label>
            </div></form>
                </div>

                <div class="col-md-5">
                    <button routerLink="/cronograma-financeiro/novo" type="button" class="btn pull-right btn-primary ">
                        Novo Cronograma</button>
                </div>

                <div class="col-md-12">
                    <hr>
                </div>

                <div class="col-md-12">
                    <p-table [value]="cronogramas" responsiveLayout="scroll" [paginator]="filtro.itensPorPagina"
                        [rows]="8" [lazy]="true" [totalRecords]="totalRegistros" (onLazyLoad)="aoMudarPagina($event)" #tabela>

                        <ng-template pTemplate="header">
                            <tr>
                                <th>Entidade Concedente</th>
                                <th>Entidade Proponente</th>
                                <th class="col-acoes"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-edit>
                            <tr>
                                <td>{{ edit.entidadeConcedente?.nome }}</td>
                                <td>{{ edit.entidadeProponente?.nome }}</td>
                                <td class="col-acoes">
                                    <a pButton icon="fa-pencil" pTooltip="Editar" tooltipPosition="top" [routerLink]="['/cronograma-financeiro', edit.id]"></a>
                                    <button pButton icon="fa-trash" pTooltip="Excluir" tooltipPosition="top" (click)="confirmarExclusao(edit)"></button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="3">Nenhum cronograma encontrado.</td>
                            </tr>
                        </ng-template>

                    </p-table>
                </div>

            </div>

            <br>
            <div class="box-footer clearfix"></div>

        </div>

    </div>